import React from 'react';

const Navbar: React.FC = () => {
    return (
        <nav className="bg-white shadow-sm sticky top-0 z-50">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div className="flex justify-between h-16">
                    <div className="flex items-center">
                        <div className="flex-shrink-0 flex items-center">
                            {/* Inline SVG */}
                            <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-shopping-cart h-8 w-8 text-green-600">
                                <circle cx="9" cy="21" r="1"></circle>
                                <circle cx="20" cy="21" r="1"></circle>
                                <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"></path>
                            </svg>
                            <span className="ml-2 text-xl font-bold text-green-600">Le Panier Clair</span>
                        </div>
                    </div>
                    <div className="hidden sm:ml-6 sm:flex sm:items-center space-x-8">
                            <a href="/" className="text-green-600 font-medium">Accueil</a>
                            <a href="/#features-section" className="text-gray-500 hover:text-green-600 font-medium">Fonctionnalités</a>
                            <a href="/#how-it-works-section" className="text-gray-500 hover:text-green-600 font-medium">Comment ça marche</a>
                            <a href="/#download-section" className="bg-green-600 text-white px-4 py-2 rounded-md font-medium hover:bg-green-700 transition">Installer l’extension</a>
                    </div>
                    <div className="-mr-2 flex items-center sm:hidden">
                        <button type="button" className="inline-flex items-center justify-center p-2 rounded-md text-gray-400 hover:text-gray-500 hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-inset focus:ring-green-500" aria-controls="mobile-menu" aria-expanded="false">
                            <i data-feather="menu"></i>
                        </button>
                    </div>
                </div>
            </div>

            {/* Mobile menu */}
            <div className="sm:hidden hidden" id="mobile-menu">
                <div className="pt-2 pb-3 space-y-1 px-4">
                        <a href="/" className="block px-3 py-2 rounded-md text-base font-medium text-green-600 bg-green-50">Accueil</a>
                        <a href="/#features-section" className="block px-3 py-2 rounded-md text-base font-medium text-gray-500 hover:text-green-600 hover:bg-green-50">Fonctionnalités</a>
                        <a href="/#how-it-works-section" className="block px-3 py-2 rounded-md text-base font-medium text-gray-500 hover:text-green-600 hover:bg-green-50">Comment ça marche</a>
                        <a href="/#download-section" className="block px-3 py-2 rounded-md text-base font-medium text-green-600 bg-green-100 hover:bg-green-200">Installer l’extension</a>
                        <a href="/privacy-policy" className="block px-3 py-2 rounded-md text-base font-medium text-gray-500 hover:text-green-600 hover:bg-green-50">Politique de confidentialité</a>
                </div>
            </div>
        </nav>
    );
};

export default Navbar;